import { Injectable } from '@angular/core';
import { IError, ILocalError, IRemoteError } from '../model/errors.interface';

@Injectable({
  providedIn: 'root'
})
export class ErrorsService {
  // #errorsConfig = inject(ERRORS_CONFIG);

  throwRemoteError(error: IRemoteError): never {
    const serverError = {
      ...error,
      ...{
        origin: 'remote'
      }
    };
    this.#throwError<IRemoteError>(serverError);
  }

  throwLocalError(error: string | ILocalError): never {
    let localError: ILocalError = typeof error === 'string' ? { message: error } : { ...error };

    const { message } = localError;

    const test = new Error(message);

    localError = {
      ...localError,
      ...{
        origin: 'local',
        message: this.formatMessage(message as string)
      }
    };

    this.#throwError<ILocalError>(test);
  }

  formatMessage(message: string): string {
    // const { localErrors } = this.#errorsConfig;
    // const { formatPrefix, formatSuffix } = localErrors;
    return message; // `${formatPrefix}${message}${formatSuffix}`;
  }

  #throwError<T extends IError>(error: T): never {
    throw error as T;
  }
}
